import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Wordpress: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width={size ?? '21'}
      height={size ?? '21'}
      fill="none"
      viewBox="0 0 21 21"
      data-testid="wordpress-icon"
    >
      <g fill={color ?? '#464342'}>
        <path d="M1.492 10.5a9.01 9.01 0 0 0 5.077 8.106L2.272 6.834c-.5 1.12-.78 2.36-.78 3.666zM16.58 10.045c0-1.113-.4-1.884-.742-2.484-.457-.742-.885-1.37-.885-2.112 0-.828.628-1.6 1.513-1.6.04 0 .077.006.116.008A8.974 8.974 0 0 0 10.5 1.493a8.997 8.997 0 0 0-7.526 4.06c.211.006.41.01.58.01.942 0 2.4-.114 2.4-.114.486-.029.543.685.058.742 0 0-.488.057-1.031.086l3.28 9.757 1.971-5.912L8.83 6.277c-.485-.029-.945-.086-.945-.086-.485-.029-.428-.77.057-.742 0 0 1.488.114 2.373.114.942 0 2.4-.114 2.4-.114.486-.029.543.684.058.742 0 0-.489.057-1.03.086l3.254 9.682.899-3.002c.389-1.246.685-2.14.685-2.912z" />
        <path d="M10.658 11.288 7.955 19.14a9.007 9.007 0 0 0 5.536-.144.791.791 0 0 1-.064-.124zM18.403 6.178c.039.287.06.595.06.926 0 .914-.17 1.942-.684 3.227l-2.751 7.955a9.004 9.004 0 0 0 4.479-7.786c0-1.566-.4-3.039-1.104-4.322z" />
        <path d="M10.5 0C4.71 0 0 4.71 0 10.5S4.71 21 10.5 21C16.289 21 21 16.29 21 10.5S16.289 0 10.5 0Zm0 20.519C4.976 20.519.48 16.024.48 10.499.481 4.977 4.976.482 10.5.482c5.523 0 10.018 4.495 10.018 10.019S16.023 20.519 10.5 20.519z" />
      </g>
    </svg>
  );
};

export default Wordpress;
